import React, {cloneElement, useState} from "react";
import "./CommonTabsPanel.sass"
import Tabs from "./Tabs";
import PropTypes from "prop-types";
import Tab from "./Tab";
import TabPanel from "./TabPanel";
import BigTab from "./BigTab";

export function CommonTabsPanel(props) {
    const [value, setValue] = useState(0);
    const {tabs, tabPanels, AdditionalTab} = props

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    return (
        <div className="common-tabs-panel-wrapper">
            <Tabs>
                {tabs.map((tab, i) => cloneElement(tab,
                    {
                        value: value,
                        index: i,
                        onClick: handleChange,
                        key: `tabs-panel-${i}`
                    }
                ))}
                {
                    AdditionalTab && <AdditionalTab/>
                }
            </Tabs>
            {
                tabPanels.map((panel, i) => cloneElement(panel,
                        {
                            value: value,
                            index: i,
                            key: `tab-panel-${i}`
                        },
                    )
                )
            }
        </div>
    );
}

CommonTabsPanel.propTypes = {
    tabs: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.shape(Tab)),
        PropTypes.arrayOf(PropTypes.shape(BigTab)),
    ]),
    AdditionalTab: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.shape(Tab)),
        PropTypes.arrayOf(PropTypes.shape(BigTab)),
    ]),
    tabPanels: PropTypes.arrayOf(PropTypes.shape(TabPanel)),
}